<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Relatórios</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">                      
                        <Dropdown v-model="linkRelatirio" :options="relatorios" optionLabel="nome" optionValue="link" @hide="carregarPagina"
                            :filter="true" placeholder="Selecione um relatório"/>
                        <hr>
                    </div>			             
                </div> 
                <router-view></router-view>
			</div>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            paginaAtual: '',
            linkRelatirio: '',
            relatorios: [],
        }
    },
    methods: {
        ...mapGetters('sessao', ['getPermissoes']),
        carregarPagina() {                
            if(this.paginaAtual != this.linkRelatirio) {
                this.paginaAtual = this.linkRelatirio;
                this.$router.push(this.linkRelatirio);
            }
        },
        updateStatus() {
            console.log('updateStatus')
        },
        carregarRelatorios() {
            let permissoes = this.getPermissoes();
            let definidos = [];
            definidos.push({nome:'Divergências', link:'/relatorios/divergencias', permissao:130});
            definidos.push({nome:'Espelho de Ponto', link:'/relatorios/espelho-ponto', permissao:129});
            definidos.push({nome:'Horas Trabalhadas', link:'/relatorios/horas-trabalhadas', permissao:131});
            definidos.push({nome:'Horas Extras Analítico', link:'/relatorios/horas-extras-analitico', permissao:132});
            definidos.push({nome:'Interjornada', link:'/relatorios/interjornada', permissao:136});
            definidos.push({nome:'Intervalo do Almoço', link:'/relatorios/intervalo-almoco', permissao:137});
            definidos.push({nome:'Domingos Trabalhados', link:'/relatorios/domingos-trabalhados', permissao:138});
            definidos.push({nome:'Saldo Banco de Horas', link:'/relatorios/saldo-banco-horas', permissao:139});
            definidos.push({nome:'Ponto Externo', link:'/relatorios/ponto-externo', permissao:147});
            definidos.push({nome:'Marcações Local Relógio', link:'/relatorios/maracacoes-local-relogio', permissao:159}); 
            definidos.push({nome:'Ocorrências Justificadas', link:'/relatorios/ocorrencias-justificadas', permissao:164});            
            definidos.forEach(relatorio => {     
                if(permissoes.includes(relatorio.permissao)) {
                    this.relatorios.push(relatorio);
                }     
            });
            this.relatorios.push({nome:'Histórico de Relatórios/Documentos', link:'/relatorios/historico', permissao:0});      
        },
        validarUrl() {         
            let tempHist = sessionStorage.getItem('tem_historico_relatorio');
            if(tempHist && this.$route.query.hist && (this.$route.query.hist == tempHist)) {
                sessionStorage.removeItem('tem_historico_relatorio');
                this.linkRelatirio = '/relatorios/historico?id=' + this.$route.query.id;
                this.carregarPagina();
                setTimeout(() => {      
                    this.linkRelatirio = '/relatorios/historico';             
                    this.paginaAtual = this.linkRelatirio; 
                }, 200);    
                return;           
            }
            let tempLinkRapidoEspelho = sessionStorage.getItem('tem_lik_rapido_espelho');            
            if(tempLinkRapidoEspelho && this.$route.query.lk_rp && (this.$route.query.lk_rp == tempLinkRapidoEspelho)) { 
                sessionStorage.removeItem('tem_lik_rapido_espelho');
                this.linkRelatirio = '/relatorios/espelho-ponto';
                this.carregarPagina();
                setTimeout(() => {  
                    this.linkRelatirio = '/relatorios/espelho-ponto';             
                    this.paginaAtual = this.linkRelatirio; 
                }, 200);               
                return;
            }
        }
    },
    mounted() {
        this.carregarRelatorios();
        this.validarUrl();
    },
    watch: {
        $route () {
            this.validarUrl();
        }
    }
}
</script>

<style>
    
</style>